<template>
  <div class="footer" :style="{position: $route.name === 'service_list' ? 'absolute':'relative'}" v-show="split">
    <div class="layout">
      <div class="infos">
        <div class="wlbm">
          <popup
            :icon="`${$cdn}images/01wx.png`"
            :hovericon="`${$cdn}images/01wx_h.png`"
            :code="`${$cdn}images/code_wx.jpg`"
          />
          <popup
            :icon="`${$cdn}images/02wb.png`"
            :hovericon="`${$cdn}images/02wb_h.png`"
            :code="`${$cdn}images/code_wb.jpg`"
          />
          <popup
            :icon="`${$cdn}images/03in.png`"
            :hovericon="`${$cdn}images/03in_h.png`"
            href="https://www.linkedin.com/company/4dage/"
          />
          <popup
            :icon="`${$cdn}images/04fb.png`"
            :hovericon="`${$cdn}images/04fb_h.png`"
            href="https://www.facebook.com/4DAGE/"
          />
          <popup
            :icon="`${$cdn}images/05dy.png`"
            :hovericon="`${$cdn}images/05dy_h.png`"
            :code="`${$cdn}images/code_dy.jpg`"
          />
        </div>
        <p v-for="(item,i) in langFooter.arr" :key="i"><span>{{item.key}}：</span>{{item.val}}</p>
      </div>
      <div class="relevant">
        <div>
          <a :href="language==='en'?'https://www.4dage.com/en':'https://www.4dage.com'" target="_blank">{{langFooter.fdage}}</a>
          <a :href="language==='en'?'https://www.cgaii.com/en':'https://www.cgaii.com'" target="_blank">{{langFooter.cgaii}}</a>
          <a href="http://www.4dmodel.com/" target="_blank">{{langFooter.model}}</a>
        </div>
        <p>Copyright © 2018 4DAGE Co., Ltd. All rights reserved. </p>
        <p><a class="a_class" href="http://www.beian.miit.gov.cn" target="_blank">粤ICP备14078495号-3</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import popup from '@/components/popup'
import {mapState} from 'vuex'

export default {
  name: 'Footer',
  components: {popup},
  computed: {
    ...mapState({
      split: state => state.ui.navDivision,
      langFooter: state => state.language.home.footer,
      language: state => state.language.current
    })
  }
}
</script>

<style lang="scss" scoped>
  .a_class,.a_class:hover,.a_class:active{
    color: #fff;
    text-decoration: none;
  }
  .footer {
    padding-top: 40px;
    padding-bottom: 50px;
    background-color: #101010 !important;
    position: relative;
    width: 100%;
    bottom: 0;
    z-index: 888;
    .layout {
      margin: 0 auto;
      max-width: 1440px;
      padding-left: 20px;
      padding-right: 20px;

      .forWK{
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 999999;
        font-size: 16px;
        color: #fff;
        opacity: 0;
      }

      .infos {
        float: left;

        .wlbm {
          margin-bottom: 15px;
          text-align: left;

          a:last-child {
            margin-right: 0;
          }
        }

        p {
          font-size: 14px;
          color: #fff;
          line-height: 1.8;

          span {
            display: inline-block;
            text-align: left;
          }
        }
      }

      .relevant {
        margin-top: 10px;
        float: right;

        div {
          margin-bottom: 8px;

          a {
            color: #1fe4dc;
            font-size: 14px;
            text-decoration: underline;
            display: inline-block;
            line-height: 25px;

            &:nth-child(2) {
              margin: 0 42px;
            }
          }
        }

        p {
          font-size: 14px;
          color: #ffffff;
          margin-bottom: 8px;
        }
      }
      &::after {
        content: '';
        display: block;
        clear: both;
      }
    }
  }

  @media screen and (max-width: 1500px) {
  .footer {
    .layout{
      max-width:1200px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/page/layout/footer.vue